import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { HomeCardTitle } from "../../components";

import { envChangeType } from "../../plugins/utils";
import { AnnouncementScroller, Banner, Menu, Overview } from "./components";
import BalanceArea from "./components/BalanceArea";
import "./style.1bbetv3.scss";
import styles from "./styleModule";

const HEADER_DATA = [
  {
    key: "child_count",
    name: "支线总人数",
    url: "/administrationCenter/subordinateManagement",
    type: "number",
    background: "#3D31DC",
  },
  {
    key: "child_register_count",
    name: "注册人数",
    url: "/administrationCenter/subordinateManagement",
    type: "number",
    background: "#09B8C8",
  },
  {
    key: "first_deposit_user_count",
    name: "首存人数",
    url: "/reportManagement/downlineReport",
    type: "number",
    background: "#F07638",
  },
];

const Home = () => {
  const { t } = useTranslation();
  const overviewRef = useRef();
  console.debug("overviewRef?.current?.getOverviewData()", overviewRef?.current?.getOverviewData());
  const renderAdditionalOverviewContent = <HomeCardTitle title={t("home.overviewTitle")} />;

  return (
    <div className={styles.container}>
      <div className={styles.scrollContainer}>
        <div
          className={styles.headerWrapper}
          style={{
            background: `url("/images/home/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/headerBackground.png") no-repeat top / cover`,
          }}
        >
          <BalanceArea
            balanceAreaContainerStyle={styles.balanceAreaContainerStyle}
            showLevelBadge={false}
            showWalletImage={true}
          />
          <div className={styles.announcementOuterContainer}>
            <AnnouncementScroller announcementContainerStyle={styles.announcementContainerStyle} />
          </div>
        </div>
        <div className={styles.bodyWrapper}>
          <Overview
            ref={overviewRef}
            homeCardContainerStyle={styles.homeCardContainerStyleOverview}
            backCardStyle={styles.backCardStyle}
            frontCardStyle={styles.frontCardStyle}
            customSearchButtonStyle={styles.customSearchButtonStyle}
            overviewDataCustomStyle={styles.overviewDataCustomStyle}
            customOverviewContentTitleStyle={styles.customOverviewContentTitleStyle}
            customOverviewContentStyle={styles.customOverviewContentStyle}
            customOverviewDropdownStyle="custom-overview-dropdown-style"
            hideTitle={true}
            gap={24}
            renderAdditionalContent={renderAdditionalOverviewContent}
            headerOverview={HEADER_DATA}
          />
          <Menu
            homeCardContainerStyle={styles.homeCardContainerStyle}
            backCardStyle={styles.backCardStyle}
            frontCardStyle={styles.frontCardStyle}
          />
        </div>

        <Banner />
      </div>
    </div>
  );
};

export default Home;
